import React from "react";
import "../LandingPage/LandingPage.css";
import Footer from "../../Components/Footer/FooterSmall";
import Header from "../../Components/Header2/Header2";
import "./SignUpTnx.css";
import { Link } from "react-router-dom";

const SignUpTnx: React.FC = () => {
  window.scrollTo({
    top: 0,
    left: 0,
    behavior: "smooth", // Optional: Adds a smooth scrolling animation
  });
  return (
    <div className="generalPage">
      <div className="landingPage">
        <Header />
        <div className="sentBody">
          <h2>Thank you for signing up!</h2>
          <h2>
            If you wish to access more information, please{" "}
            <Link to="/user-login">login</Link> and complete an MNDA. You will
            receive an email notification from ICE GEMS once you have access to
            protected information with your login.
          </h2>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default SignUpTnx;
